/**
 * Computes "Order today, get it by [date]" from the visitor's real local
 * date, skipping weekends -- runs client-side so it reflects the actual
 * moment of viewing, not Liquid's render-time 'now' (which would be stale for
 * however long the page stays CDN-cached).
 *
 * Day counts (min/max business days) come from data attributes set in
 * snippets/delivery-estimate.liquid, sourced from real Printful shipping
 * quotes -- see that file's header for the numbers and where they came from.
 */
class DeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const minDays = parseInt(this.dataset.minDays, 10) || 6;
    const maxDays = parseInt(this.dataset.maxDays, 10) || 10;
    const textEl = this.querySelector('[data-delivery-text]');
    if (!textEl) return;

    const minDate = this.addBusinessDays(new Date(), minDays);
    const maxDate = this.addBusinessDays(new Date(), maxDays);

    const fmt = { month: 'short', day: 'numeric' };
    const minStr = minDate.toLocaleDateString('en-US', fmt);
    const maxStr = maxDate.toLocaleDateString('en-US', fmt);

    textEl.textContent =
      minStr === maxStr
        ? `Order today, get it around ${minStr}`
        : `Order today, get it between ${minStr}–${maxStr}`;
  }

  addBusinessDays(startDate, days) {
    const date = new Date(startDate);
    let remaining = days;
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) remaining -= 1; // skip Sun(0)/Sat(6)
    }
    return date;
  }
}

customElements.define('delivery-estimate', DeliveryEstimate);
